export const nanoid = (size = 12): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID().replace(/-/g, '').slice(0, size);
  }

  const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let id = '';
  for (let i = 0; i < size; i += 1) {
    const idx = Math.floor(Math.random() * chars.length);
    id += chars[idx];
  }
  return id;
};
